import { render, staticRenderFns } from "./EvaluationDataTable.vue?vue&type=template&id=51990880&scoped=true&"
import script from "./EvaluationDataTable.vue?vue&type=script&lang=ts&"
export * from "./EvaluationDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./EvaluationDataTable.vue?vue&type=style&index=0&id=51990880&prod&lang=css&"
import style1 from "./EvaluationDataTable.vue?vue&type=style&index=1&id=51990880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51990880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VDataTable,VIcon,VRow,VSelect,VTextField})
